import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO helper — titre, meta description, canonical, OG tags.
 * Indexation pilotée par REACT_APP_PUBLIC_INDEXING ; prop `noindex` pour forcer
 * le blocage page par page (extranet, pages privées, remerciements…).
 */
const SITE_INDEXING = process.env.REACT_APP_PUBLIC_INDEXING === "true";
const SITE_ORIGIN = "https://domainedelabriouse.com";
const DEFAULT_DESCRIPTION =
  "Domaine de la Briouse à Sanxay (Vienne, 86), entre Poitiers et Niort : chambres d'hôtes, gîtes, mariages, séminaires, haras et événements.";
const DEFAULT_OG_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/og-image.jpg`;

export default function SEO({
  title,
  description,
  canonical,
  ogImage,
  locale = "fr",
  type = "website",
  noindex = false,
  publicIndexing,
  exact = false,
}) {
  React.useEffect(() => {
    document.querySelectorAll("[data-seo-static]").forEach((el) => el.remove());
  }, []);
  const fullTitle = title
    ? (exact || title.includes("Briouse") ? title : `${title} — Domaine de la Briouse`)
    : "Domaine de la Briouse — Sanxay (86), entre Poitiers et Niort";
  const desc = description || DEFAULT_DESCRIPTION;
  const indexable = publicIndexing !== undefined ? publicIndexing : SITE_INDEXING;
  const canonicalUrl = canonical || (indexable && !noindex
    ? `${SITE_ORIGIN}${window.location.pathname.replace(/\/+$/, "") || "/"}`
    : null);
  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {(noindex || !indexable) && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage || DEFAULT_OG_IMAGE} />
      <meta property="og:locale" content={locale === "en" ? "en_GB" : "fr_FR"} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
